import {
  selectHiddenOnMapGpsVehicleIds,
  selectHighlightedRoutesGpsVehicleId,
} from 'app/containers/Map/slice/selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import RouteMapItems from '../RouteMapItems/RouteMapItems';
import { useAllRoutesMapItems } from './hooks/useAllRoutesMapItems';

type Props = {};

const AllRoutesMapItems: React.FC<Props> = () => {
  const { routes, onFieldClick } = useAllRoutesMapItems();
  const hiddenGpsVehicleIds = useSelector(selectHiddenOnMapGpsVehicleIds);

  const visibleRoutes = routes.filter(
    route => !hiddenGpsVehicleIds.includes(route.gpsVehicle.id),
  );

  const highlightedRoutesGpsVehicleId = useSelector(
    selectHighlightedRoutesGpsVehicleId,
  );

  return (
    <RouteMapItems
      routes={visibleRoutes}
      onFieldClick={onFieldClick}
      isHighlightRouteEnabled={true}
      highlightedRoutesGpsVehicleId={highlightedRoutesGpsVehicleId}
    />
  );
};

export default AllRoutesMapItems;
